var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNfpaLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.099,94.932l-8.264-9.925v9.925s-6.395,0-6.395,0v-18.847s5.947,0,5.947,0l8.264,9.925v-9.925s6.395,0,6.395,0v18.847s-5.948,0-5.948,0Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.048,88.887v6.045s-6.789,0-6.789,0v-18.847s16.21,0,16.21,0v5.015s-9.421,0-9.421,0v2.772s8.895,0,8.895,0v5.015s-8.895,0-8.895,0Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.179,94.932v-18.847s9.5,0,9.5,0c2.983,0,5.206.559,6.671,1.677s2.198,2.811,2.198,5.081c0,2.306-.755,4.012-2.263,5.121-1.509,1.108-3.816,1.663-6.921,1.663h-2.658s0,5.306,0,5.306h-6.526Zm9-10.241c1.017,0,1.737-.141,2.158-.422s.632-.757.632-1.426c0-.651-.215-1.117-.645-1.399-.43-.281-1.127-.422-2.092-.422h-2.527s0,3.669,0,3.669h2.474Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.363,94.932l-1-2.772h-7.869s-.973,2.772-.973,2.772h-6.842s7.79-18.847,7.79-18.847h8.105s7.789,18.847,7.789,18.847h-7Zm-4.921-13.778l-2.184,6.018h4.342s-2.158-6.018-2.158-6.018Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.686,77.658l-.703-1.19h-.806s0,1.19,0,1.19h-.973v-3.51h1.794c1.045,0,1.568.388,1.568,1.165,0,.233-.051.427-.153.582-.102.156-.257.281-.467.376l.86,1.386h-1.121Zm-.752-1.937c.223,0,.385-.033.487-.098.102-.066.153-.172.153-.32,0-.144-.048-.248-.145-.312-.097-.064-.258-.096-.484-.096h-.767s0,.826,0,.826h.757Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.766,79.622c-2.04,0-3.699-1.659-3.699-3.699s1.659-3.7,3.699-3.7,3.699,1.659,3.699,3.7-1.659,3.699-3.699,3.699Zm0-6.922c-1.777,0-3.223,1.446-3.223,3.223s1.446,3.222,3.223,3.222,3.223-1.445,3.223-3.222-1.446-3.223-3.223-3.223Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.522,5.083H16.497c-3.93,0-7.127,3.197-7.127,7.128v53.133c0,3.93,3.197,7.126,7.127,7.126h15.093v-9.673h-9.535c-1.66,0-3.01-1.35-3.01-3.01V17.836c0-1.698,1.381-3.079,3.08-3.079h55.683c1.747,0,3.169,1.422,3.169,3.169v41.942c0,1.615-1.314,2.929-2.929,2.929h-9.617v9.673h15.093c3.93,0,7.126-3.197,7.126-7.126V12.21c0-3.93-3.197-7.128-7.126-7.128Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.317,18.148c.037-.147.25-.133.267.017.205,1.75.44,5.49,3.978,9.537,3.827,4.378,3.74,8.654,3.415,10.938-.088.618-.36,2.403-.489,3.27-.02.135-.204.16-.258.035-.354-.807-1.157-2.522-2.039-3.602-2.361-2.89-5.238-5.238-5.907-10.923-.378-3.215.602-7.571,1.033-9.272Zm17.065,35.077c1.568-8.399-5.82-20.09-7.92-23.19-.088-.129-.285-.03-.238.119,2.914,9.295-1.992,15.905-2.951,17.078-.064.078-.187.047-.208-.052-1.308-6.276-6.534-11.811-8.97-14.951-1.898-2.446-2.142-5.012-2.079-6.108.008-.131-.167-.176-.228-.061-.573,1.088-1.705,4.111-.223,9.185,1.822,6.234.979,8.899.607,9.669-.05.104-.201.091-.241-.017-1.748-4.81-3.724-8.12-5.364-10.303-1.407-1.872-2.566-2.916-3.123-3.365-.102-.082-.251.016-.212.14.391,1.237,2.807,4.24-2.414,17.702-3.012,7.765,2.816,13.957,4.106,15.027.087.072.212-.006.193-.117-.621-3.552.386-6.361.831-7.374.054-.124.235-.094.254.04,1.251,8.913,6.35,13.192,7.349,13.953.077.059.188.01.203-.086.607-3.795,1.646-5.05,2.895-7.944,1.587-3.675,1.291-7.817,1.057-9.593-.02-.154.193-.214.26-.074,5.371,11.213,1.974,18.401,1.105,19.931-.058.101.065.242.155.168,7.948-6.536,10.354-15.493,10.88-17.922.02-.094.157-.081.163.015.249,4.11-.379,7.256-.697,8.399-.032.114.112.193.191.104.952-1.071,3.544-4.609,4.62-10.372Z",
    fill: "#fff",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfpaLogoWhite);
export default __webpack_public_path__ + "static/media/nfpa-logo-white.2df745482dfe92a38372864d6eb470d8.svg";
export { ForwardRef as ReactComponent };